export const faq = [
  {
    q: '¿Cuánto dura el programa?',
    a: 'Random College no tiene fecha de fin. Pagas una suscripción y tienes acceso indefinido mientras seas miembro. El contenido se actualiza constantemente con nuevos módulos y clases en directo.',
  },
  {
    q: '¿Necesito experiencia previa?',
    a: 'No. Los módulos están diseñados para que puedas empezar desde cero, tanto si nunca has hecho marketing como si ya tienes un negocio en marcha. Hay contenido para todos los niveles.',
  },
  {
    q: '¿Cómo funciona la plataforma Skool?',
    a: 'Skool es una plataforma todo-en-uno donde encontrarás los cursos, el feed de la comunidad, el ranking de alumnos y los eventos en directo. Se accede desde navegador o desde la app móvil, sin instalaciones complicadas.',
  },
  {
    q: '¿Puedo cancelar en cualquier momento?',
    a: 'Sí. La suscripción es mensual y puedes cancelarla cuando quieras desde tu cuenta de Skool. No hay permanencias ni penalizaciones.',
  },
  {
    q: '¿Hay clases en directo?',
    a: 'Sí. Hacemos sesiones en directo periódicas donde los profesores responden dudas, hacen tutoriales en tiempo real y comparten casos de estudio actualizados.',
  },
  {
    q: '¿Cuánto cuesta?',
    a: 'El precio exacto lo encontrarás en la página de Skool. Es una suscripción mensual accesible, diseñada para que la inversión se recupere en las primeras semanas aplicando lo aprendido.',
  },
];
